<template>
    <section class="dashboard">
        <div class="container">
            <div class="dashboard__top">
                <h3 class="title-h3 text-center">
                    {{$t("studio.dashboard.title_members")}}
                </h3>
                <div class="list">
                    <DashboardCheckinGuest/>
                    <DashboardItem
                            v-for="(member, idx) in members"
                            :key="idx"
                            :route="member.route"
                            :type="member.type"
                            :title="member.text"
                    />
                </div>
            </div>

            <div class="dashboard__bottom">
                <h3 class="title-h3 text-center">
                    {{$t("studio.dashboard.title_statistic")}}
                </h3>
                <div class="list">
                    <DashboardItem
                            v-for="(statistic, idx) in statistics"
                            :key="idx"
                            :route="statistic.route"
                            :type="statistic.type"
                            :title="statistic.text"
                    />
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    import DashboardCheckinGuest from './DashboardCheckinGuest'
    import DashboardItem from './DashboardItem'
    export default {
        components: {
            DashboardCheckinGuest,
            DashboardItem
        },
        data() {
            return {
                members: [
                    {
                        route: '/studios/members/new-member',
                        text: this.$t('studio.dashboard.members.new_member'),
                        type: 'new-member'
                    },
                    {
                        route: '/studios/members',
                        text: this.$t('studio.dashboard.members.view_members'),
                        type: 'view-members'
                    }
                ],
                statistics: [
                    {
                        route: '/studios/statistics/members',
                        text: this.$t('studio.dashboard.statistics.member_statistics'),
                        type: 'statistic-members'
                    },
                    {
                        route: '/studios/statistics/guests',
                        text: this.$t('studio.dashboard.statistics.guest_statistics'),
                        type: 'guest-statistics'
                    },
                    {
                        // route: '',
                        route: '/studios/partner-studios',
                        text: this.$t('studio.dashboard.statistics.partner_studios'),
                        type: 'partner-studios'
                    }
                ]
            }
        }
    }
</script>

